"use strict";
// 凡是进入jdh页面，往下生成的订单，前端上传新增的source=39，都加上对应的问诊来源
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.seoMarkForSeoOrderMark = exports.seoOrderAimSource = exports.seoOrderScenceArr = exports.seoMarkForSeoOrderKey = void 0;
exports.seoMarkForSeoOrderKey = "seoMarkForSeoOrder";
// 场景值：217（追问包/source=1）、14（专家团队/source=1）、128（图文追问/source=1）、127（限次图文/source=1）、70（私人医生问诊/source=1）、69（定向普通视频问诊/source=1）、68（定向普通电话问诊/source=1）、67（定向普通图文问诊/source=1）、66（义诊预约电话/source=1）、65（义诊图文问诊/source=1）、37（极速电话/source=1&9）、114（普通极速图文/source=1&9）、115（京医速诊/source=1&9）
// 夜间图文：360、夜间电话：278、门诊大厅-电话问诊：285、门诊大厅-视频问诊：286、门诊大厅-图文问诊：309
exports.seoOrderScenceArr = [
    217, 14, 128, 127, 70, 69, 68, 67, 66, 65, 37, 114, 115, 360, 278, 285, 286,
    309, 392, 393, 390, 391, 394, 395,
];
exports.seoOrderAimSource = 39;
function seoMarkForSeoOrderMark(param, submitOrderFunc, functionId) {
    if (!submitOrderFunc.includes(functionId)) {
        return param;
    }
    var seoMarkForSeoOrderStr = window.localStorage.getItem(exports.seoMarkForSeoOrderKey);
    if (!seoMarkForSeoOrderStr) {
        return param;
    }
    var seoMarkForSeoOrderInfo = JSON.parse(seoMarkForSeoOrderStr);
    var overdue = Number(seoMarkForSeoOrderInfo.overdue);
    if (overdue) {
        if (new Date().getTime() < overdue) {
            if (exports.seoOrderScenceArr.includes(Number(param.data.body.businessScene)) ||
                exports.seoOrderScenceArr.includes(Number(param.data.body.scene))) {
                var _param = __assign({}, param);
                _param.data.body = __assign(__assign({}, param.data.body), { source: exports.seoOrderAimSource });
                console.log("该订单已计入seo");
                return _param;
            }
        }
        else {
            window.localStorage.removeItem(exports.seoMarkForSeoOrderKey);
        }
    }
    console.log("该订单不符合seo条件，不记录到seo中");
    return param;
}
exports.seoMarkForSeoOrderMark = seoMarkForSeoOrderMark;
